export const MAX_LOCATION_NAMES = 200;

// Slot value for creating a Center on an existing Left/Right pair. Never send
// this to the create mutations -- those expect LR / LCR / Single / a custom string.
export const EXISTING_CENTER_SLOT = "existing_center";

const TRAILING_NUMBER = /^(.*?)(\d+)$/;

export const expandLocationNameRange = (fromValue, toValue) => {
  const from = (fromValue || "").trim();
  const to = (toValue || "").trim();

  if (!from || !to) return { names: [], error: null };

  const fromMatch = from.match(TRAILING_NUMBER);
  const toMatch = to.match(TRAILING_NUMBER);

  if (!fromMatch || !toMatch) {
    return {
      names: [],
      error: "From and To must end in a number, like V001 and V020",
    };
  }

  if (fromMatch[1] !== toMatch[1]) {
    return { names: [], error: "From and To must share the same prefix" };
  }

  const start = Number(fromMatch[2]);
  const end = Number(toMatch[2]);

  if (end < start) {
    return { names: [], error: "To must be greater than or equal to From" };
  }

  const count = end - start + 1;
  if (count > MAX_LOCATION_NAMES) {
    return {
      names: [],
      error: `Cannot create more than ${MAX_LOCATION_NAMES} locations at once`,
    };
  }

  const width = fromMatch[2].length;
  const names = [];

  for (let n = start; n <= end; n += 1) {
    names.push(`${fromMatch[1]}${String(n).padStart(width, "0")}`);
  }

  return { names, error: null };
};

export const namesForCreate = values => {
  if (values.slot === EXISTING_CENTER_SLOT) {
    return { names: values.missingCenterNames || [], error: null };
  }

  if (values.creatingMode === "multiple") {
    return expandLocationNameRange(values.locationFrom, values.locationTo);
  }

  const name = (values.locationName || "").trim();
  return name ? { names: [name], error: null } : { names: [], error: null };
};

export const slotSuffixes = (locationType, slot, customSlot) => {
  if (locationType !== "rack") return [""];

  const mode = slot === "Custom" ? customSlot : slot;
  if (mode === EXISTING_CENTER_SLOT) return [" (Center)"];
  if (mode === "LR") return [" (Left)", " (Right)"];
  if (mode === "LCR") return [" (Left)", " (Center)", " (Right)"];
  return [""];
};

export const previewLines = (names, locationType, slot, customSlot) => {
  const suffixes = slotSuffixes(locationType, slot, customSlot);
  return names.map(name => suffixes.map(suffix => `${name}${suffix}`).join("    "));
};

export const locationCountForNames = (names, locationType, slot, customSlot) =>
  names.length * slotSuffixes(locationType, slot, customSlot).length;

export const previewSummary = (names, locationType, slot, customSlot) => {
  const locationCount = locationCountForNames(names, locationType, slot, customSlot);
  if (!locationCount) return "";

  return `Creating ${locationCount} ${locationCount === 1 ? "location" : "locations"}`;
};
